import { DollarSign, Folders, HardDrive, Map, Sparkles } from 'lucide-react';

const SIDEBAR_WIDTH = 230;

const SIDEBAR_MENU_ITEMS = [
  {
    label: 'Data Center',
    icon: HardDrive,
    path: '/dashboard/data-center',
  },
  {
    label: 'Territories',
    icon: Map,
    path: '/dashboard/territories',
  },
  {
    label: 'Financial Overview',
    icon: DollarSign,
    path: '/dashboard/financial-overview',
  },
  {
    label: 'Library',
    icon: Folders,
    path: '/dashboard/library',
  },
  {
    label: 'Ask Aimei',
    icon: Sparkles,
    path: '/dashboard/ask-aimei',
  },
];

export { SIDEBAR_MENU_ITEMS, SIDEBAR_WIDTH };
